import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { DefaultResolver } from './default.resolver';
import { AdditionalDocsService } from '../additional-docs/additional-docs.service';

@Injectable()
export class AdditionalDocResolver extends DefaultResolver implements Resolve<any> {

    constructor(private additionalDocService: AdditionalDocsService) {
        super();
    }

    resolve(route: ActivatedRouteSnapshot) {
        return this.additionalDocService.getDocNames();
    }
}



// WEBPACK FOOTER //
// ./src/app/resolvers/additional-doc.resolver.ts